import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

const INITIAL_GROUP_PARAM_VALUE = 'p1';
export const GROUP_PARAM_KEY = 'group';
export const GRAPH_PARAM_KEY = 'graph';

export const useActivityReportSearchParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    let selectedGroup = searchParams.get(GROUP_PARAM_KEY);
    const selectedGraph = searchParams.get(GRAPH_PARAM_KEY);

    // only set the value if there are no values in the search params we are looking for
    if (selectedGroup === null && selectedGraph === null) {
        selectedGroup = INITIAL_GROUP_PARAM_VALUE;
    }

    const setActivityReportSearchParams = useCallback(
        (key: string, param: string) => setSearchParams(new URLSearchParams({ [key]: param })),
        [setSearchParams],
    );

    return [selectedGroup, selectedGraph, setActivityReportSearchParams] as const;
};
